import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import { CustomState } from "@waytek/Store/Reducers";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = ({ customInvoiceHistoryState: { tabSelected } }: CustomState) => ({ tabSelected });

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasShellContext;

const InvoiceHistoryTabContent = ({ id, shellContext: { isInShell }, tabSelected }: Props) => {
    if (isInShell) {
        return (
            <StyledWrapper>
                <Accordion headingLevel={3}>
                    <AccordionSection title="Zone: Content by Invoice">
                        <Zone contentId={id as never} zoneName={"ContentByInvoice" as never} />
                    </AccordionSection>

                    <AccordionSection title="Zone: Content by Summary">
                        <Zone contentId={id as never} zoneName={"ContentBySummary" as never} />
                    </AccordionSection>
                </Accordion>
            </StyledWrapper>
        );
    }

    if (tabSelected === 0) {
        return <Zone contentId={id as never} zoneName={"ContentByInvoice" as never} />;
    }
    return <Zone contentId={id as never} zoneName={"ContentBySummary" as never} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withIsInShell(InvoiceHistoryTabContent)) as any,
    definition: {
        group: "Invoice History",
        displayName: "Tab Content",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
